import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CoachSectionCard from '../ui/CoachSectionCard'
import ActiveCalendarEducation from './ActiveCalendarEducation'
import {
  BRIEFING_KEY_CALENDAR_HINT,
  isBriefingRead,
  markBriefingRead,
} from '../../lib/coachBriefingReadState'

type ActiveCalendarCardProps = {
  onConnect?: () => void
  unlockHint?: string | null
}

const ActiveCalendarCard = ({ onConnect, unlockHint }: ActiveCalendarCardProps) => {
  const { t } = useTranslation()
  const [readVersion, setReadVersion] = useState(0)
  const [expanded, setExpanded] = useState(false)

  const badge = useMemo(() => {
    void readVersion
    return isBriefingRead(BRIEFING_KEY_CALENDAR_HINT) ? 0 : 1
  }, [readVersion])

  const markRead = () => {
    markBriefingRead(BRIEFING_KEY_CALENDAR_HINT)
    setReadVersion((v) => v + 1)
  }

  return (
    <CoachSectionCard
      title={t('coach.activeCalendar.badge')}
      icon="calendar_month"
      badge={badge}
      defaultExpanded={false}
      expanded={expanded}
      onExpandedChange={setExpanded}
      teaser={t('coach.activeCalendar.title')}
      onExpand={markRead}
    >
      <ActiveCalendarEducation embedded onConnect={onConnect} unlockHint={unlockHint} />
    </CoachSectionCard>
  )
}

export default ActiveCalendarCard
